import React from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const DEFAULT_STEPS = [
  { n: "01", t: "Define", d: "Tell us exactly what you need." },
  { n: "02", t: "Source", d: "We identify and screen relevant opportunities." },
  { n: "03", t: "Curate", d: "Suitable options are assessed and presented against your requirements." },
  { n: "04", t: "Connect", d: "Qualified opportunities progress to confidential disclosure, introduction and transaction engagement." },
];

export default function HowItWorks({ content }) {
  const eyebrow = content?.eyebrow || "How It Works";
  const heading = content?.heading || "From brief to introduction.";
  const steps = content?.steps?.length ? content.steps : DEFAULT_STEPS;

  return (
    <section id="how-it-works" data-testid="how-it-works" className="relative overflow-hidden bg-seablue/20 px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">{heading}</h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="h-full bg-obsidian p-8" data-testid={`step-${s.n}`}>
                <div className="font-mono text-3xl text-gold/40">{s.n}</div>
                <h3 className="mt-5 font-serif text-2xl text-warmwhite">{s.t}</h3>
                <p className="mt-3 font-sans text-sm leading-relaxed text-softgrey">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
